import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", {
  "data-name": "Group 6101",
  transform: "translate(-7578 -561)"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    "data-name": "Ellipse 56",
    cx: "12",
    cy: "12",
    r: "12",
    transform: "translate(7578 561)",
    style: {"fill":"#f59600"}
  }),
  /*#__PURE__*/_createElementVNode("path", {
    "data-name": "Path 9088",
    d: "M15 3.707 14.293 3 5.5 11.792 1.707 8 1 8.707l4.5 4.5z",
    transform: "translate(7582 564.896)",
    style: {"fill-rule":"evenodd"}
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render };